import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import excelIcon from "../../assets/images/excel-icon.png";
import excelBlackIcon from "../../assets/images/excel-black-icon.png";
import { makeExcelDepositData, makeExcelSepData } from "../Table/makeData";
import ExcelExportButtonProps from "./ExcelExportButtonProps";
import { useSelector } from "react-redux";
import { exportExcelData } from "./ExcelExportUtil";
import "./ExcelExportButton.scss";


const ExcelExportButton = (props: ExcelExportButtonProps) => {
  const { t } = useTranslation("common");
  const { userId, firstName, lastName } = useSelector(
    (state: any) => state.UserReducer
  );

  const mainTableHeaders = [
    { name: t("excel.movementReport.employeeName") },
    { name: t("excel.movementReport.idNumber") },
    { name: t("excel.movementReport.gemel") },
    // TODO: will be in use in 'vatika' don't delete the following code
    // { name: t("excel.movementReport.gemelApproval") },
    { name: t("excel.movementReport.employerName") },
    { name: t("excel.movementReport.depositDate") },
    { name: t("excel.movementReport.forMonthSalary") },
    { name: t("excel.movementReport.employeeBenefits") , key: "A1" },
    { name: t("excel.movementReport.employerBenefits"), key: "A2" },
    { name: t("excel.movementReport.compensation"), key: "A3" },
    { name: t("excel.movementReport.lossOfWorkingCapacity"), key: "A4" },
    { name: t("excel.movementReport.difference"), key: "A5" },
    { name: t("excel.movementReport.employeeBenefits2"), key: "B1" },
    { name: t("excel.movementReport.employerBenefits2"), key: "B2" },
    { name: t("excel.movementReport.compensation2"), key: "B3" },
    { name: t("excel.movementReport.lossOfWorkingCapacity2"), key: "B4" },
    { name: t("excel.movementReport.difference2"), key: "B5" },
    { name: t("excel.movementReport.absorptionAccordingToTheReport") },
  ];
  
  const sepTableHeaders = [
    { name: t("excel.movementReportBefore2018.employeeName") },
    { name: t("excel.movementReportBefore2018.idNumber") },
    { name: t("excel.movementReportBefore2018.gemel") },
    // TODO: will be in use in 'vatika' don't delete the following code
    // { name: t("excel.movementReportBefore2018.gemelApproval") },
    { name: t("excel.movementReportBefore2018.employerName")},
    { name: t("excel.movementReportBefore2018.depositDate")},
    { name: t("excel.movementReportBefore2018.forMonthSalary")},
    { name: t("excel.movementReportBefore2018.depositSum")},
    { name: t("excel.movementReportBefore2018.employeeBenefits") },
    { name: t("excel.movementReportBefore2018.employerBenefits")},
    { name: t("excel.movementReportBefore2018.compensation")},
    { name: t("excel.movementReportBefore2018.depositType")}
  ];
  



const mainTableName = t("excel.movementReport.depositReport") 
const sepTableName = t("excel.movementReport.movementReport")
const excelfooter1 = t("excel.excelfooter1")
const excelfooter2 = t("excel.excelfooter2")
const excelfooter3 = t("excel.excelfooter3")
const idNumber = t("excel.movementReport.idNumber")
const createDate = t("excel.movementReport.createDate")
const currentDate = t("excel.movementReport.currentDate")
const employersReportInNIS = t("excel.movementReport.employersReportInNIS")
const divisionIntoProvision = t("excel.movementReport.divisionIntoMemberEmployerAccount")
const fullyAscribedYes = t("general.yes")
const fullyAscribedNo = t("general.no")


 const exportData = () => {
    exportExcelData(
      props.exportMainTable ? mainTableHeaders : sepTableHeaders,
      data,
      userId,
      props.exportMainTable
        ? props?.tableData[0]?.dateUpdated
        : props?.tableData[0]?.dateUpdate,
      props.exportMainTable,     
      sepTableName,
      mainTableName,
      excelfooter1,
      excelfooter2,
      excelfooter3,
      idNumber,
      createDate,
      currentDate,
      employersReportInNIS,
      divisionIntoProvision
    );
  };

  const data = useMemo(
    () =>
      props.exportMainTable
        ? makeExcelDepositData(props.tableData, `${firstName} ${lastName}`,fullyAscribedYes,fullyAscribedNo)
        : makeExcelSepData(props.tableData, `${firstName} ${lastName}`),
    [props.tableData, props.exportMainTable]
  );

  return (
    <button
      className="deposits-excel-export-button"
      style={{ display: `${props.disableButton() ? "none" : ""}` }}
      onClick={exportData}
    >
      <span>{t("deposits.exportToExcel")}</span>
      <img src={excelIcon} alt="excel" />
    </button>
  );
};

export default ExcelExportButton;
